import styled, { css } from 'styled-components';
import { BORDER_RADIUS, media, mediaMap, OVERLAYS, Z_INDEX } from '@belong/themes';
import { ICard } from '@belong/types';
import { LinearProgress as LinearProgressBar, PROGRESS_BAR_HEIGHT } from '@belong/ui-core';
import { UICard } from '../../styles/UICard';

export const CardWrapper = styled(UICard).attrs(props => ({
  borderVariant: props.borderVariant === 'shadow' ? 'shadow' : undefined
}))<ICard>`
  position: relative;

  ${({ hasSectionPaddingTop }) => css`
    ${hasSectionPaddingTop &&
    mediaMap(
      {
        xs: -3.2,
        md: 0
      },
      (margin: number) => css`
        margin-top: ${margin}rem;
      `
    )};
  `}
`;

export const CardContent = styled.div<ICard>`
  position: relative;
  padding: 2.4rem 0 1.6rem;

  ${({ disabled }) =>
    disabled &&
    css`
      &::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: ${OVERLAYS.WHITE};
        z-index: ${Z_INDEX.CARD_BUSY_OVERLAY};
      }
    `}

  ${media('md')`
    padding: 3.2rem 2.4rem 2.4rem;
  `}
`;

export const LinearProgress = styled(LinearProgressBar)`
  border-top-left-radius: ${BORDER_RADIUS.CARD};
  border-top-right-radius: ${BORDER_RADIUS.CARD};
`;

export const CardBusy = styled.div`
  border-top-left-radius: ${BORDER_RADIUS.CARD};
  border-top-right-radius: ${BORDER_RADIUS.CARD};
  height: ${PROGRESS_BAR_HEIGHT};
  width: 100%;
  position: sticky;
  z-index: ${Z_INDEX.CARD_BUSY_PROGRESS_BAR};
  top: 0;
`;
